import { imageUrl } from '../lib/images';

export default function Logo({ className = '', variant = 'light', size = 'default' }) {
  // Height sizing
  const heightClass =
    size === 'lg'
      ? 'h-16 sm:h-20'
      : size === 'sm'
      ? 'h-9 sm:h-10'
      : 'h-13 sm:h-15';

  return (
    <div className={`inline-flex items-center select-none ${className}`}>
      <img
        src={imageUrl('/_assets/unknown-2.png', 'width=500,format=auto')}
        alt="Lunde Media Logo"
        className={`${heightClass} w-auto object-contain transition-transform duration-300 group-hover:scale-[1.02]`}
        loading="eager"
      />
    </div>
  );
}
